import React from 'react';
import PlantImage from 'assets/images/plant.png';
import { Container } from 'library';

import CMSContent from '../../common/CMSContent/CMSContent';

import './WhoWeAreBlock.scss';

const WhoWeAreBlock = ({ heading, content }) => {
  return (
    <div className="WhoWeAreContainer">
      <div className="WhoWeAreWrapper">
        <div className="WhoWeAre">
          <Container className="WhoWeAreContent">
            <h2 className="WhoWeAreHeading">{heading}</h2>
            <CMSContent content={content} />
          </Container>

          <figure className="WhoWeAreSideImage">
            <img src={PlantImage} alt="" />
          </figure>
        </div>
      </div>
      <hr />
    </div>
  );
};

export default WhoWeAreBlock;
